export default "__VITE_ASSET__BO_JH04y__"